import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Inertia } from '@inertiajs/inertia';

const FeaturedCouponsBtns = ({id, coupon_id}) => {

  const handleDelete = () => {
    if (confirm('Are you sure you want to delete this coupon from category?')) {
      Inertia.delete(route('categories.remove.coupon', id), {
        data: {coupon_id}
      });
    }
  }

  return (
    <div className={'flex'}>
      <button className='mr-3' onClick={handleDelete} data-tip="Remove coupon">
        <FontAwesomeIcon
          color={'red'}
          size={'lg'}
          icon={solid('xmark')}/>
      </button>
    </div>
  );
};

export default FeaturedCouponsBtns;
